import { gql } from "@apollo/client";

/**
 * Hands back the whole list rather than the one row it changed, so the screen
 * cannot render a stale count beside a switch that has just moved.
 */
export const SET_FEATURE_FLAG = gql`
  mutation SetFeatureFlag($feature: String!, $studentId: ID!, $enabled: Boolean!) {
    setFeatureFlag(feature: $feature, studentId: $studentId, enabled: $enabled) {
      errors
      flags {
        id
        key
        name
        description
        enabledCount
        accounts {
          id
          accountId
          name
          email
          role
          learnerCount
          enabled
        }
      }
    }
  }
`;
